export const PROFILE = 'profile';
export const ACCOUNT = 'accounts';
export const BILLING = 'billing';

let  profileUrls = [
    {
        id: 'personalInformation',
        title: 'Personal Information',
        link: '',
        exact: true,
        account: false,        

    }, {
        title: 'Linked Accounts',
        link: 'linkedaccounts',
        account: false

    }, {
        title: 'Change Login Email',
        link: 'changeloginemail',
        account: false

    }, {
        title: 'Change Password',
        link: 'ChangePassword',
        account: false

    }, {
        title: 'Change Security Questions',
        link: `changesecurityquestions`,
        account: false
    }
];

profileUrls = profileUrls.map(p=>({...p, hideOnBranding: true}));

const billingUrls = [
    {
        title: 'Make a Payment',
        link: 'makeapayment',
        account: true,
        exact: true,
        isActive: (match, location) => {
            const regex = /^(\/?billing\/\d*\/makeapayment\/?)|(\/?billing\/\d*\/?)$/;
            return regex.test(location.pathname);
        },

    }, {
        id: 'billingHistory',
        title: 'Billing Activity',
        link: 'activity',
        exact: true,
        account: true

    }, {
        title: 'Payment Method',
        link: 'paymentsettings',
        account: true

    }, {
        title: 'Buyout Quote',
        link: `buyoutquote`,
        account: true
    }
];

const accountsUrls = [
    {
        id: 'accountDetails',
        title: 'Account Details',
        link: '',
        exact: true,
        isActive: (match, location) => {
            const accountRegex = /^(\/?accounts\/\d*\/edit\/?)|(\/?accounts\/\d*\/?)$/;
            return accountRegex.test(location.pathname);
        },
        account: true

    }, {
        title: 'Leases',
        link: 'leases',
        account: true
    },
    {
        title: 'Documents',
        link: 'documents',
        account: true
    }
];

const mapper = i => ({
    ...i,
    id: i.id
        ? i.id
        : i.link,
    exact: typeof i.exact === 'undefined'
        ? false
        : i.exact
});

export const getUrls = (module) => {
    if (module === PROFILE) {
        return profileUrls.map(mapper);

    } else if (module === ACCOUNT) {
        return accountsUrls.map(mapper);

    } else if (module === BILLING) {
        return billingUrls.map(mapper);
    }

    throw new Error('not supported module name');
}